import React, { useState } from "react";
import { Formik } from "formik";
import {Button, LoginPage as TablerLoginPage} from "tabler-react";
import {useHistory} from "react-router-dom";
import {useAuth} from "../../hooks/AuthContext";

import logo from "../../assets/img/logo.svg";
import "./loginMonitor.css";
import {Alerta} from "../../utils/Alerta";


function LoginMonitor() {
  const history = useHistory();

  const { signInMonitor, signOut } = useAuth();

  function handleSignOut() {
    try {
      signOut();
      history.push("/");
    } catch (err) {
      Alerta("Erro ao efetuar logout");
    }
  }

  const [emailMagazord, setEmailMagazord] = useState<string>()
  const [passwordMagazord, setPasswordMagazord] = useState<string>()
    const [isOldPassword, setIsOldPassword] = useState(false);

  async function handleLogin (email?: string, password?: string) {
    try {
      const res = await signInMonitor({
        email: emailMagazord ?? email,
        password: password? password : passwordMagazord!,
        secret: "1",
      });

      // @ts-ignore
      if (typeof res == 'string' && res.includes('A sua senha é muito antiga')) {
        setIsOldPassword(true);
        Alerta(res);
        return;
      }

      if (!!email && !!password){
        setEmailMagazord(email)
        setPasswordMagazord(password)
      }

      history.push("/login-monitor-store");
    } catch (err) {
      Alerta("Login ou senha incorretos");
    }
  }

  return (
    <>
      <Button.List className="button-out">
        <Button
          href="#"
          outline
          size="sm"
          RootComponent="a"
          color="primary"
          pill
          onClick={handleSignOut}
        >
          Sair
        </Button>
        {isOldPassword
          ? <Button
            href="https://dashboard.monitor-v2.magazord.com.br/confirm-mail"
            outline
            size="sm"
            RootComponent="a"
            color="primary"
            pill
          >
            Solicitar nova senha
          </Button>
          : ''
        }
      </Button.List>
      <Formik
        initialValues={{
          email: "",
          password: "",
          name: "",
        }}
        validate={(values) => {
          let errors: any = {};
          if (!values.email) {
            errors.email = "Obrigatório";
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = "Endereço de e-mail inválido";
          }
          return errors;
        }}
        onSubmit={async (
          values,
          { setSubmitting, setErrors /* setValues and other goodies */ }
        ) => {
            handleLogin(values.email, values.password);
        }}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <TablerLoginPage
            onSubmit={handleSubmit}
            onChange={handleChange}
            onBlur={handleBlur}
            values={values}
            errors={errors}
            touched={touched}
            logoUrl={logo}
            strings={{
              title: "Login Magazord",
              buttonText: "Login",
              emailLabel: "Email Magazord",
              emailPlaceholder: "Email Magazord",
              passwordLabel: "Senha",
              passwordPlaceholder: "Senha",
            }}
          />
        )}
      />
    </>
  );
}

export default LoginMonitor;
